// Money with the euro sign as a suffix (12.34€) — the reservation pages'
// convention, shared so the same amount never renders two ways.
export const eur = (v: number) => `${(v ?? 0).toFixed(2)}€`;
